import type { ThemeConfig } from 'antd';

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#2d72d2',
    colorError: '#cd4246',
    colorSuccess: '#238551',
    colorWarning: '#c87619',
    borderRadius: 4,
    fontSize: 14,
  },
};
